<div class="forget-password-wrapper">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Forget Password</h4>
      </div>
      <div class="card-body">
        <form [formGroup]="forgetPasswordForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label for="email">Email</label>
            <input type="email" class="form-control" id="email" formControlName="email">
            <div class="invalid-feedback" *ngIf="forgetPasswordForm.get('email')?.invalid && (forgetPasswordForm.get('email')?.dirty || forgetPasswordForm.get('email')?.touched)">
              <div *ngIf="forgetPasswordForm.get('email')?.errors?.['required']">Email is required</div>
              <div *ngIf="forgetPasswordForm.get('email')?.errors?.['email']">Email is invalid</div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary" [disabled]="forgetPasswordForm.invalid">Reset Password</button>
        </form>
      </div>
    </div>
  </div>
  